import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { ProfileTab, PROFILE_TAB_OPTIONS } from "../constants";

type ProfileTabBarProps = {
  activeTab: ProfileTab;
  onTabChange: (tab: ProfileTab) => void;
};

export const ProfileTabBar = ({ activeTab, onTabChange }: ProfileTabBarProps) => {
  const play = usePlaySound();

  const handleTabChange = (tab: ProfileTab) => {
    play();
    onTabChange(tab);
  };

  return (
    <div className="flex-row-center h-[74px] mb-4 bg-beige-60 rounded-[12px] border-[4px] border-solid border-white">
      {PROFILE_TAB_OPTIONS.map((option, index) => {
        const isActive = activeTab === option.key;
        const isFirst = index === 0;
        const isLast = index === PROFILE_TAB_OPTIONS.length - 1;
        return (
          <div
            key={option.key}
            onClick={() => handleTabChange(option.key)}
            className={`flex-col-center cursor-pointer flex-1 h-full select-none active:scale-95 ${
              isActive ? "bg-green-alt" : ""
            } ${isFirst ? "rounded-l-[8px]" : ""} ${isLast ? "rounded-r-[8px]" : ""}`}
          >
            <p className="text text-textcolor-black !text-[20px] !leading-[22px]">
              {I18n.t(option.labelKey)}
            </p>
          </div>
        );
      })}
    </div>
  );
};
